import * as r from "react";
import { forwardRef as t } from "react";
import { c as l } from "./index.js-Cr0Rsuyz.mjs";
function a(e, o) {
  return /* @__PURE__ */ r.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: o
  }, e), /* @__PURE__ */ r.createElement("path", {
    fill: "currentColor",
    d: "M18.116 8.116a1.25 1.25 0 1 1 1.768 1.768l-7 7a1.25 1.25 0 0 1-1.768 0l-7-7a1.25 1.25 0 1 1 1.768-1.768L12 14.232z"
  }));
}
var m = l(/* @__PURE__ */ t(a));
export {
  m as I
};
